<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :md="6" :sm="12">
            <a-form-item label="页面名称">
              <a-input
                v-model="queryParam.pageName"
                placeholder="请输入页面名称"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="页面状态">
              <j-dict-select-tag
                v-model="queryParam.status"
                placeholder="请选择页面状态"
                dictCode="obj_status"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <span
              style="float: left; overflow: hidden"
              class="table-page-search-submitButtons"
            >
              <a-button type="primary" @click="searchQuery" icon="search"
                >查询</a-button
              >
              <a-button
                type="primary"
                @click="searchReset"
                icon="reload"
                style="margin-left: 8px"
                >重置</a-button
              >
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!--  页面添加模块  -->
    <template>
      <j-modal
        title="页面模块添加"
        width="700px"
        :visible="addModulesFlag"
        :confirmLoading="confirmLoading"
        switchFullscreen
        @ok="handleAddOk"
        @cancel="handleAddCancel"
        cancelText="关闭"
      >
        <a-spin :spinning="confirmLoading">
          <a-button @click="handleAddModules" type="primary" icon="plus"
            >添加</a-button
          >
          <a-form>
            <!--<a-form-item label="关联奖品" :labelCol="labelCol" :wrapperCol="wrapperCol" v-for="(item, index) in arr" :key="index">
              <a-select v-model="relevancePrizes[index]" placeholder="请选择关联奖品">
                <a-select-option v-if="prizesList != null" v-for="(item, index) in prizesList" :value="item.id" :key="index">{{item.prizesName}}</a-select-option>
              </a-select>
            </a-form-item>-->

            <a-form-item
              label="模块"
              v-for="(item, index) in arr"
              :key="index"
              style="margin-left: 10px"
            >
              <a-select
                mode="multiple"
                v-model="pageModuleIds[index]"
                placeholder="请选择需要使用的模块"
                style="width: 60%; margin-left: 50px; margin-top: 5px"
              >
                <a-select-option
                  v-for="(item, index) in moduleList"
                  :value="item.id"
                  :key="index"
                  >{{ item.eventName }}</a-select-option
                >
              </a-select>
              <a-button
                style="margin-left: 50px"
                @click="handleDelModules(index)"
                icon="minus"
                >删除</a-button
              >
            </a-form-item>
          </a-form>
        </a-spin>
      </j-modal>
    </template>

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"
            ><a-icon type="delete" />删除</a-menu-item
          >
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作 <a-icon type="down"
        /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a
        >项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange,
        }"
        class="j-table-force-nowrap"
        @change="handleTableChange"
      >
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px; font-style: italic"
            >无图片</span
          >
          <img
            v-else
            :src="getImgView(text)"
            height="25px"
            alt=""
            style="max-width: 80px; font-size: 12px; font-style: italic"
          />
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px; font-style: italic"
            >无文件</span
          >
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="uploadFile(text)"
          >
            下载
          </a-button>
        </template>
        <template slot="status" slot-scope="text, record">
          <a-switch
            :checked="isChecked(record.status)"
            checked-children="启用"
            un-checked-children="禁用"
            @click="handleChange(record)"
          />
        </template>

        <span slot="action" slot-scope="text, record">
          <a
            @click="handleEdit(record)"
            :disabled="record.status == 1 ? true : false"
            >编辑</a
          >
          <a-divider type="vertical" />
          <!--<a @click="addModulesHandle(record)">模块配置</a>
          <a-divider type="vertical" />-->
          <a
            @click="handleDelete(record.id)"
            :disabled="record.status == 1 ? true : false"
            >删除</a
          >
        </span>
      </a-table>
    </div>

    <page-module-modal ref="modalForm" @ok="modalFormOk"></page-module-modal>
  </a-card>
</template>

<script>
import '@/assets/less/TableExpand.less';
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import PageModuleModal from './modules/PageModuleModal';
import { getAction } from '../../../api/manage';
import { httpAction, postAction } from '@/api/manage';
import customRender from '@/utils/customRender.js';

export default {
  name: 'pageModule',
  mixins: [JeecgListMixin],
  components: {
    PageModuleModal,
  },
  data() {
    return {
      description: '页面管理页面',
      loading: false,

      confirmLoading: false,
      addModulesFlag: false, //模块添加是否展示
      modelId: '',
      arr: [1],
      moduleList: [], //模块集合
      pageModuleIds: [], //添加的模块集合

      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 15 },
      },
      // 表头
      columns: [
        {
          title: '页面名称',
          align: 'center',
          dataIndex: 'pageName',
          ellipsis: true,
          customRender: customRender,
          // customRender: function (text) {
          //   return !text
          //     ? ''
          //     : text.length > 12
          //     ? text.substr(0, 12) + '...'
          //     : text;
          // },
        },
        {
          title: '页面描述',
          align: 'center',
          dataIndex: 'pageDescribe',
          ellipsis: true,
          customRender: customRender,
          // customRender: function (text) {
          //   return !text
          //     ? '--'
          //     : text.length > 12
          //     ? text.substr(0, 12) + '...'
          //     : text;
          // },
        },
        {
          title: '起止时间',
          align: 'center',
          ellipsis: true,
          dataIndex: 'pageStartEndTime',
          customRender: customRender,
        },
        {
          title: '创建时间',
          align: 'center',
          dataIndex: 'createTime',
        },
        {
          title: '当前状态',
          align: 'center',
          dataIndex: 'status_dictText',
          scopedSlots: { customRender: 'status' },
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          // fixed:"right",
          width: 147,
          scopedSlots: { customRender: 'action' },
        },
      ],
      dataSource: [],
      /* 分页参数 */
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0,
      },
      url: {
        list: process.env.VUE_APP_CMS_MARKETING + '/page/modules/list',
        delete: process.env.VUE_APP_CMS_MARKETING + '/page/modules/delete',
        edit: process.env.VUE_APP_CMS_MARKETING + '/page/modules/edit',
        queryById:
          process.env.VUE_APP_CMS_MARKETING + '/page/modules/queryById',
        deleteBatch:
          process.env.VUE_APP_CMS_MARKETING + '/page/modules/deleteBatch',
        updateStatus:
          process.env.VUE_APP_CMS_MARKETING + '/page/modules/updateStatus',
        updateMiddle:
          process.env.VUE_APP_CMS_MARKETING + '/page/modules/updateMiddle',
        getMiddleByPageId:
          process.env.VUE_APP_CMS_MARKETING + '/page/modules/getMiddleByPageId',
      },
      dictOptions: {},
    };
  },
  computed: {},
  methods: {
    // 单个删除
    handleDelete: function (id) {
      if (!this.url.delete) {
        this.$message.error('请设置url.delete属性!');
        return;
      }
      var that = this;
      this.$confirm({
        title: '确认删除',
        content: '是否删除选中数据?',
        onOk: function () {
          that.loading = true;
          postAction(that.url.delete, { id: id })
            .then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.loadData(1);
              } else {
                that.$message.warning(res.message);
              }
            })
            .finally(() => {
              that.loading = false;
            });
        },
      });
    },
    // 批量删除
    batchDel: function () {
      if (!this.url.deleteBatch) {
        this.$message.error('请设置url.deleteBatch属性!');
        return;
      }
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning('请选择一条记录！');
        return;
      } else {
        var ids = '';
        for (var a = 0; a < this.selectedRowKeys.length; a++) {
          ids += this.selectedRowKeys[a] + ',';
        }
        var that = this;
        this.$confirm({
          title: '确认删除',
          content: '是否删除选中数据?',
          onOk: function () {
            that.loading = true;
            postAction(that.url.deleteBatch, { ids: ids })
              .then((res) => {
                if (res.success) {
                  that.$message.success(res.message);
                  that.loadData(1);
                  that.onClearSelected();
                } else {
                  that.$message.warning(res.message);
                }
              })
              .finally(() => {
                that.loading = false;
              });
          },
        });
      }
    },
    initDictConfig() {},
    //启用、停用
    handleChange(record) {
      let strOpen = '确定要启用所选数据?';
      let strClose = '确定要禁用所选数据?';
      var that = this;
      var type = record.status === 1 ? 0 : 1;
      this.$confirm({
        title: record.status === 1 ? '禁用' : '启用',
        content: record.status === 1 ? strClose : strOpen,
        onOk() {
          postAction(that.url.updateStatus, {
            ids: record.id,
            type: type,
          }).then((res) => {
            if (res.success) {
              //刷新页面
              that.loadData();
              that.$message.success(res.message);
            } else {
              that.$message.error(res.message);
            }
          });
        },
      });
    },

    isChecked(statusTemp) {
      if (statusTemp === 1) {
        return true;
      } else return false;
    },

    loadDataTmp() {
      if (!this.url.list) {
        this.$message.error('请设置url.list属性!');
        return;
      }
      this.loading = true;
      getAction(this.url.list).then((res) => {
        if (res.success) {
          this.dataSource = res.result.records;
          this.ipagination.total = res.result.total;
        }
        if (res.code === 510) {
          this.$message.warning(res.message);
        }
        this.loading = false;
      });
    },

    addModulesHandle(model) {
      this.addModulesFlag = true; //展示模态框
      this.modelId = model.id;
      this.getEventList();
      this.getSelectedModules();
    },

    handleAddModules() {
      let newArr = [1];
      this.arr = this.arr.concat(newArr);
      console.log(this.arr);
    },

    handleDelModules(index) {
      console.log(index);
      this.arr.splice(index, 1);
      this.pageModuleIds.splice(index, 1);
    },

    handleAddOk() {
      //增加模块，入库
      const that = this;
      that.confirmLoading = true;
      if (that.pageModuleIds.length === 0 || !that.modelId) {
        that.$message.error('添加失败,缺少参数!');
      }

      let paprms = {
        pageId: that.modelId,
        pageModuleIds: JSON.stringify(that.pageModuleIds),
      };
      console.log('提交参数pageId:' + paprms.pageId);
      console.log('提交参数pageModuleIds:' + paprms.pageModuleIds);
      httpAction(that.url.updateMiddle, paprms, 'put')
        .then((res) => {
          if (res.success) {
            that.$message.success(res.message);
            that.$emit('ok');
          } else {
            that.$message.warning(res.message);
          }
        })
        .finally(() => {
          that.confirmLoading = false;
          that.$emit('close');
          that.addModulesFlag = false;
        });
    },

    handleAddCancel() {
      //取消增加模块
      this.$emit('close');
      this.addModulesFlag = false;
    },

    /**获取活动列表*/
    getEventList() {
      let getUrl =
        process.env.VUE_APP_GATEWAY_URL +
        process.env.VUE_APP_CMS_MARKETING +
        '/activity/getEventList';
      getAction(getUrl).then((res) => {
        if (res.success) {
          this.moduleList = res.result;
        }
      });
    },

    /**获取已有的模块配置*/
    getSelectedModules() {
      this.confirmLoading = true;
      this.arr = [];
      this.pageModuleIds = [];
      getAction(this.url.getMiddleByPageId, { pageId: this.modelId }).then(
        (res) => {
          if (res.success) {
            if (res.result.length !== 0) {
              console.log(res.result);
              //this.arr = res.result.length;
              res.result.forEach((item) => {
                if (item.pageModuleId.indexOf(',') !== -1) {
                  this.pageModuleIds.push(item.pageModuleId.split(','));
                } else {
                  this.pageModuleIds.push(item.pageModuleId);
                }
                this.arr.push(this.pageModuleIds);
              });
              //this.pageModuleIds = this.arr;
              console.log(this.arr);
            } else {
              this.arr = [1];
              this.pageModuleIds = [];
            }
            this.confirmLoading = false;
          }
        }
      );
    },
    //分页
    handleTableChange(pagination, filters, sorter) {
      this.onClearSelected(); //分页切换时清空表格选中
      //分页、排序、筛选变化时触发
      if (Object.keys(sorter).length > 0) {
        this.isorter.column = sorter.field;
        this.isorter.order = 'ascend' == sorter.order ? 'asc' : 'desc';
      }
      this.ipagination = pagination;
      this.loadData();
    },
  },
};
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
